import React, { useEffect, useState } from "react";
import HeartLoader from "@/components/HeartLoader";
import { useParams, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Eye, Loader2 } from "lucide-react";
import { api } from "@/lib/api";

export default function PublicStory() {
  const { slug } = useParams();
  const [story, setStory] = useState(undefined);

  useEffect(() => { api.get(`/story/public/${slug}`).then((r) => setStory(r.data.story)).catch(() => setStory(null)); }, [slug]);

  if (story === undefined) return <div className="min-h-screen grid place-items-center"><HeartLoader /></div>;
  if (story === null) return <div className="min-h-screen grid place-items-center text-sec">This story isn't available.</div>;

  return (
    <div className="max-w-3xl mx-auto px-5 sm:px-8 py-16">
      <Link to="/" className="flex items-center gap-2 mb-8"><Eye size={24} className="text-brand rotate-90" /><span className="font-serif text-2xl">My Kind</span></Link>
      <motion.h1 initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} className="font-serif text-4xl sm:text-5xl tracking-tighter">{story.title}</motion.h1>
      {story.narrative && <p className="text-sec leading-relaxed mt-6 whitespace-pre-wrap">{story.narrative}</p>}
      <div className="grid sm:grid-cols-2 gap-3 mt-10">
        {(story.moments || []).map((m, i) => (
          <motion.div key={i} initial={{ opacity: 0, y: 10 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="rud-card rounded-2xl overflow-hidden">
            {m.media_url && (m.media_type === "video"
              ? <video src={m.media_url} controls className="w-full h-56 object-cover" />
              : <img src={m.media_url} alt="" className="w-full h-56 object-cover" />)}
            <div className="p-4"><div className="font-serif text-xl">{m.title}</div><div className="text-sec text-sm mt-1">{m.note}</div></div>
          </motion.div>
        ))}
      </div>
      <p className="text-xs text-sec mt-12 text-center">Crafted with My Kind — a Universal, Self-Evolving AI PaaS.</p>
    </div>
  );
}
